import { render, staticRenderFns } from "./MobilePlatformModuleGrid.vue?vue&type=template&id=56fbaff4&scoped=true"
import script from "./MobilePlatformModuleGrid.vue?vue&type=script&lang=js"
export * from "./MobilePlatformModuleGrid.vue?vue&type=script&lang=js"
import style0 from "./MobilePlatformModuleGrid.vue?vue&type=style&index=0&id=56fbaff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fbaff4",
  null
  
)

export default component.exports